export default "__VITE_ASSET__BCsUQUkk__"